import React from 'react';
import { motion } from 'framer-motion';
import { MdRoofing } from 'react-icons/md';
import { AiFillCheckCircle } from 'react-icons/ai';
import { IoMdCall } from 'react-icons/io';
import './About.css';

import aboutContImge from '../../assets/images/about-one-shape.png';
import aboutimg01 from '../../assets/images/about_img01.jpg';
import aboutimg02 from '../../assets/images/about_img02.jpg';

function About() {
  return (
    <section className="about" id="About">
      <img className="about__watermark" src={aboutContImge} alt="" aria-hidden="true" />

      <div className="container">
        <div className="about__inner">
          
          {/* Left Content */}
          <motion.div 
            className="about__content"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6 }}
          >
            <div className="about__header">
              <div className="section-label">
                <MdRoofing aria-hidden="true" />
                About Our Company
              </div>
              <h2 className="about__title">Experienced & Quality Roofing Services Providers</h2>
              <p className="about__desc">
                With years of industry experience, Central Industries Kandy provides unparalleled 
                roofing solutions. From residential installations to large-scale commercial projects, 
                our focus remains strictly on quality, longevity, and aesthetics. We deliver results 
                that stand the test of time.
              </p>
            </div>

            <div className="about__cards">
              <motion.div 
                className="about__card"
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.2 }}
              >
                <div className="about__card-header">
                  <AiFillCheckCircle className="about__card-icon" aria-hidden="true" />
                  <h3 className="about__card-title">Vision</h3>
                </div>
                <p>
                  To provide uninterrupted services optimizing customer satisfaction and to become 
                  the leading manufacturer and distributor in Sri Lanka.
                </p>
              </motion.div>

              <motion.div 
                className="about__card"
                initial={{ opacity: 0, scale: 0.95 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: 0.4 }}
              >
                <div className="about__card-header">
                  <AiFillCheckCircle className="about__card-icon" aria-hidden="true" />
                  <h3 className="about__card-title">Mission</h3>
                </div>
                <p>
                  To supply products efficiently and effectively with supreme quality, fulfilling 
                  all customer requirements to the absolute fullest.
                </p>
              </motion.div>
            </div>

            <motion.a 
              href="https://wa.me/+94763607727" 
              target="_blank" 
              rel="noreferrer" 
              className="button"
              initial={{ opacity: 0 }}
              whileInView={{ opacity: 1 }}
              viewport={{ once: true }}
              transition={{ duration: 0.4, delay: 0.6 }}
            >
              <IoMdCall aria-hidden="true" />
              <span>Contact Us</span>
            </motion.a>
          </motion.div>

          {/* Right Images */}
          <motion.div 
            className="about__images"
            initial={{ opacity: 0, x: 30 }}
            whileInView={{ opacity: 1, x: 0 }}
            viewport={{ once: true, margin: "-100px" }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <img className="about__img-main" src={aboutimg01} alt="Team performing roof installation" />
            <img className="about__img-side" src={aboutimg02} alt="Finished residential roof" />
          </motion.div>

        </div>
      </div>
    </section>
  );
}

export default About;